// extracted by mini-css-extract-plugin
export default {"iconContainer":"IconContainer_iconContainer__Vyrg0","icon":"IconContainer_icon__eCe64","description":"IconContainer_description__SXJLg"};